export default __webpack_public_path__ + "static/purple_fibre_logo-fda2dd5138379b3e186224ad84dd64c3.png";